import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Link } from "gatsby-plugin-modal-routing";
import { css } from "@emotion/core";
import Container from 'react-bootstrap/Container';
import styled from "@emotion/styled";
import Layout from "../components/layout";
import Section1 from "../sections/he-for-she-section1";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, SearchBox, Configure, connectHits, Highlight, Menu, Pagination } from 'react-instantsearch-dom';
import 'instantsearch.css/themes/algolia.css';
import Section2 from "../sections/he-for-she-section2";
import Section4 from "../sections/he-for-she-section4";
import Section5 from "../sections/he-for-she-section3";
import Section6 from "../sections/he-for-she-section6";
import Section7 from "../sections/he-for-she-section7";
import SEO from "../components/seo";
import { isMentorImageValid } from "../utils/mentor-image";

const HeForSheMenuTitle = styled.span`
  display:block;
  float:left;
  font: bold 16px/28px Roboto;
  @media(max-width:768px) {
    margin-bottom:10px;
  }
  @media(max-width:576px) {
    float: none;
    text-align:center;
  }
`
const HeForSheMenu = styled(Menu)`
  .ais-Menu-count {
    display:none;
  }
  ul li{
    display: inline;
  }
  .ais-Menu-item {
    margin-left:5%;
  }
  .ais-Menu-link {
    display: inline-block;
    padding-bottom:10px;
  }
  .ais-Menu-label {
    color: ${props => props.theme.colors.primary_violet}; 
    &:hover, &:focus, &.focus, &:active, &.active  {
      color: ${props => props.theme.colors.gray_dark};
    }
  }
  .ais-Menu-item--selected .ais-Menu-label {
    color: ${props => props.theme.colors.gray_dark};
    border-bottom: 3px solid;
    padding-bottom: 3px;
  }
`

const HeForShePagination = styled(Pagination)`
  .ais-Pagination-link {
    width:33.98px;
    height:38px;
    padding-top:8px;
    text-align:center;
    font: 1rem Roboto;
    border-radius:0;
    border: 1px solid ${props => props.theme.colors.gray_border};
    border-left:0;
    color:${props => props.theme.colors.primary_violet};
    &:hover, &:focus, &.focus, &:active, &.active  {
      color:${props => props.theme.colors.white};
      background-color:${props => props.theme.colors.primary_violet}; 
      border-color:${props => props.theme.colors.primary_violet}; 
    }
  }
  .ais-Pagination-item--previousPage .ais-Pagination-link {
    border-left: 1px solid ${props => props.theme.colors.gray_border};
    border-top-left-radius:.25rem;
    border-bottom-left-radius:.25rem;
  }
  .ais-Pagination-item--nextPage .ais-Pagination-link {
    border-top-right-radius:.25rem;
    border-bottom-right-radius:.25rem;
  }
  .ais-Pagination-link--selected {
    color:${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.gray_dark} !important;
    border-color: ${props => props.theme.colors.gray_dark} !important;
  }
  .ais-Pagination-item + .ais-Pagination-item {
    margin-left:0;
  }
  @media(max-width:767px) {
    justify-content: center !important;
  }
  @media(min-width:768px) {
    float:right;
  }
`

const SecondSectionContainer = styled(Container)`
  margin-top:34px;
  margin-bottom:100px;
  @media(max-width:767px) {
    margin-top:15px;
    margin-bottom:20px;
  }
`
const SecondSectionCard = styled(Button)`
  padding:0;
  color: ${props => props.theme.colors.gray_dark};
  background-color: ${props => props.theme.colors.white};
  border-color: ${props => props.theme.colors.gray_border};
  font: 16px/22px Roboto;
  transition: 0.25s ease-out;
  @media(max-width:767px) {
    width:100%;
  }
  &:hover {
    color: ${props => props.theme.colors.gray_dark};
    background-color: ${props => props.theme.colors.white};
    border-color: ${props => props.theme.colors.gray_border};
    box-shadow: 0px 3px 5px ${props => props.theme.buttons.secondary_small_button_violet.hovered.shadow} !important;
    cursor: pointer;
  }
  &:focus, &.focus, &:active, &.active {
    color: ${props => props.theme.colors.gray_dark};
    background-color: ${props => props.theme.colors.white};
    border-color: ${props => props.theme.colors.gray_border};
    box-shadow: none;
    cursor: pointer;
  }
`
const SecondSectionCardBody = styled(Card.Body)`
  text-align:center;
  padding-top:15px;
  padding-left:25px;
  padding-right:25px;
  @media(min-width:768px) {
    height:220px;
    word-break: break-word;
  }
  @media(min-width:992px) {
    height:140px;
  }
`
const SecondSectionCardTitle = styled(Card.Title)`
  font: Bold 16px/22px Roboto;
  margin-bottom:10px;
`
const SecondSectionCardSubtitle = styled(Card.Subtitle)`
  font: 16px/22px Roboto;
`
const HeForSheHighlight = styled(Highlight)`
  .ais-Highlight-highlighted, .ais-Snippet-highlighted {
    background-color: ${props => props.theme.colors.accent_yellow};
  }
`


const Hits = ({ hits }) => (
  <Row>
    {hits.map(hit => (
      <Col md="3" css={css`margin-top:15px;`}>
        <Link
          to={"/he-for-she/" + hit.name.trim().replace(/ /gi, '-').toLowerCase()} 
          asModal
        >
          
          <SecondSectionCard variant="light">
            <Card.Img alt={"WomenWorks HeForShe - " + hit.name} variant="top" 
                src={isMentorImageValid(hit.photoLink)? hit.photoLink : "/heforshe/"+ hit.name.trim().replace(/ /gi, '-').toLowerCase()+".jpg"}
                css={ css` ${isMentorImageValid(hit.photoLink)? `filter: grayscale(100%);` : ``} 
                object-fit:cover;
                @media(max-width:767px) {
                  width:100%;
                  height: calc(383/767*100vw);
                  max-width: 508px;
                  max-height: 383px;
                }
                @media(min-width:768px) {
                  width:calc(253/1440*100vw);
                  height: calc(191/1440*100vw);
                  max-width: 253px;
                  max-height: 191px;
                }` }
                />
            <SecondSectionCardBody>
              <SecondSectionCardTitle>
                <HeForSheHighlight attribute="name" hit={hit} />
              </SecondSectionCardTitle>
              <SecondSectionCardSubtitle>
                <HeForSheHighlight attribute="title" hit={hit} />
              </SecondSectionCardSubtitle>
            </SecondSectionCardBody>
          </SecondSectionCard>

        </Link>
      </Col>
    ))}
  </Row>
);

const HeForSheHits = styled(connectHits(Hits))`
  .ais-Hits-item {
    border: none;
    box-shadow: none;
  }
`
const SearchTitle = styled.div`
  color : ${props => props.theme.colors.gray_dark};
  margin-top:61px;
  font: 58px/62px Abril Fatface;
  text-align:center;
  margin-bottom:35px;
  @media(max-width:767px){
    font: 2.5rem/3rem Abril Fatface;
    margin-top:20px;
    margin-bottom:15px;
  }
`
const TitleContainer = styled(Container)`
  border-bottom: 2px solid ${props => props.theme.colors.gray_border};
`

const AlgoliaKey = require("../utils/algolia-credentials")

export default class HeForShe extends React.Component {
  render() {
    const searchClient = algoliasearch(
      AlgoliaKey.appId,
      AlgoliaKey.searchKey,
    )

  return (
    <Layout 
      LogoColor={props => props.theme.colors.secondary_green} 
      HeaderMenuColor={props => props.theme.colors.gray_dark} 
      firstSectionBGColor={props => props.theme.colors.white}

      //button
      HeaderButtonColor={props => props.theme.buttons.primary_small_button_yellow_gray.normal.color} 
      HeaderButtonBorder={props => props.theme.buttons.primary_small_button_yellow_gray.normal.border_color} 
      HeaderButtonBackground={props => props.theme.buttons.primary_small_button_yellow_gray.normal.background_color}
      
      HeaderButtonColorHover={props => props.theme.buttons.primary_small_button_yellow_gray.hovered.color}
      HeaderButtonBorderHover={props => props.theme.buttons.primary_small_button_yellow_gray.hovered.border_color} 
      HeaderButtonBackgroundHover={props => props.theme.buttons.primary_small_button_yellow_gray.hovered.background_color}

      HeaderButtonColorPressed={props => props.theme.buttons.primary_small_button_yellow_gray.pressed.color}
      HeaderButtonBorderPressed={props => props.theme.buttons.primary_small_button_yellow_gray.pressed.border_color} 
      HeaderButtonBackgroundPressed={props => props.theme.buttons.primary_small_button_yellow_gray.pressed.background_color}
    >

      <SEO title={"Stronger TogetHER byWomenWorks"} description={"A women-first connection and virtual knowledge sharing platform to build meaningful connections between men and women in order to grow and advance in their professional life. All men will undergo a tight vetting process by WomenWorks."} />
      <Section1></Section1>
      <InstantSearch searchClient={searchClient} indexName="Male_Mentors">
          <TitleContainer>
            <SearchTitle>
              Our Male Mentors
            </SearchTitle>
          </TitleContainer>
          <Container>
            <Row className="justify-content-center">
              <Col xs="12" xl="10" css={css`margin-top:25px;text-align:center;`}>
                <HeForSheMenuTitle>
                  Filter mentors by their specialties:
                </HeForSheMenuTitle>
                <HeForSheMenu attribute="categories" />
              </Col>
            </Row>
            <Row id="mentors">
              <Col xs="12" md="6" lg="5" css={css`padding-top:35px;@media(max-width:576px){padding-top:10px;}`}>
                  <SearchBox css={css`.ais-SearchBox-submit, .ais-SearchBox-reset {z-index:0;}.ais-SearchBox-input{height:38px;}`}
                    translations={{
                    placeholder: 'Search mentor’s name, title, or other keywords',
                  }}/>
              </Col>
              <Col xs="12" md="6" lg="7" css={css`padding-top:35px;@media(max-width:576px){padding-top:20px;}`}>
                  <HeForShePagination
                    showFirst={false} 
                  />
                
              </Col>
            </Row>
          </Container>
          
          <SecondSectionContainer>
            <Configure hitsPerPage={8} />
            <HeForSheHits />
          </SecondSectionContainer>
          
        </InstantSearch>
      <Section2/>
      <Section4
        BackgroundRight={props=>props.theme.colors.white_dark}
        BackgroundLeft={props=>props.theme.colors.accent_yellow70}
        TextColor= {props => props.theme.colors.gray_dark}
        DisplayButton="none"
      />
      <Section5/>
      <Section6/>
       <Section7 
          DisplaySection='none'
          Title = 'What our Mentors are saying about WomenWorks:'
          Testimonials ={ [
            {content: (<div>“Mentoring with WomenWorks has been an immensely rewarding experience. While I'm expected to ‘teach’ my mentees, I also receive tremendous learning opportunities from the process. As I advise others, I get to reflect my own life journey and development. Moreover, WomenWorks does an excellent job matching me with bright talented young women that I often learn something back from them in return.
            “</div>), 
              name: "Amirah Kaca", 
              title: "Public Policy Consultant ", 
              image:"/testimonials/amirah-kaca.jpg"},
            {content: (<div>“Mentorship is one of the critical things that has helped me both in my personal and professional development journeys through the generous help, insights, and advice from my mentors. Now I'm glad for platforms like WomenWorks that allow me to pay it forward and extend the empowerment to the next circle of women!”</div>), 
              name: "Metha Trisnawati", 
              title: "Co-Founder and COO Sayurbox",
              image: "/mentor/metha-trisnawati.png"},
            {content: (<div>“I think joining Women Works was one of the great decisions I made. Not only could I share my good and bad experiences of being a women who works, but also I could learn more from other badass women out there, my mentees and my fellow mentors. It is a privilege to be a part of a movement where women empower and inspire each other rather than compete with one another. It’s about time!”</div>), 
              name: "Priska Sufhana", 
              title: "Legal staff to Board of Commissioner at a state owned company",
              image: "/mentor/priska-sufhana.png"},
          ]}
        >
        </Section7>
    </Layout>   
  )
}
}
